import React, { PropTypes, Component } from 'react';
import './refList.less';
import mobx from 'mobx';
import { observer } from "mobx-react";
import { Ticon } from '../../index';
import tools from '../../utils/tools';
import { tools as vTools} from 'tplus-voucher';



@observer
export default class RefList extends Component {

  state = {}

  constructor(props) {
    super(props);
  }

  handleSelect = (e, it) => {
    tools.preventEvent(e);
    if (this.props.isCustomize) { // 自定义项 只返回 returnValue 对应的值
      this.props.onSelected(it['returnValue']);
    } else {
      this.props.onSelected(it);
    }
  }

  getDesensitizationInfo = (ID,FieldName,event) =>{
    event.stopPropagation();
    const {getDesensitizationInfo} = this.props;
    if(getDesensitizationInfo){
      getDesensitizationInfo(ID,FieldName);
    }
  }

  renderDesensitizationIcon = (item,template,desensitizationFileds) =>{
    if(desensitizationFileds.indexOf(template.Field) >- 1 && item[template.Field] && item[template.Field].indexOf("***")>-1){
      return <span onClick={this.getDesensitizationInfo.bind(this,item.ID||item.Id,template.Field)} className='tuominyincang-icon icon-n-tuominxianshi iconfont md' />
    }
    return null;
  }

  render() {
    const text = '&nbsp;&nbsp;&nbsp;&nbsp;'
    const {
      items = [],
      onSelected,
      localSearch,
      rowID,
      selecteds,
      isCustomize, // 是否是自定义项
      template, // 决定怎么显示的模板
      RefShowField, // 默认第一行显示这个字段，没有的话 显示Name
      desensitizationFileds
    } = this.props;

    const fonts = vTools.getLocalCache('fonts');
    const className = fonts && fonts.ID == '1' ? 'refListVoucher-X' : 'refListVoucher'


    return (
      <div className={className}>
        {items.length <= 0 ? <div>没有找到任何数据</div> : null}
        {items.map((it, i) => {
          if (it.clear) {
            // return (<div key={-1} onClick={(e) => this.handleSelect(e, isCustomize ? {returnValue: null} : { Id: null, Name: null, Code: null })}>清空</div>)
            return null;
          }
          return (
            <div
              key={i}
              onClick={(e) => this.handleSelect(e, it)}>
              <div className='refList-content'>

                {
                  isCustomize ?
                    <div className='line-overflow-1 row-title'>{it[Object.keys(it)[1]]}</div>
                    :
                    null
                }

                {/* 自定义项 */}
                {
                  isCustomize ?
                    Object.keys(it).map((item, j) => {
                      if (j == 0 || j == 1) {
                        return null;
                      }
                      let value = it[item];
                      return (
                        <div className='line-overflow-1 row-line' style={{ width: '50%', display: 'inline-block' }}>{item}&nbsp;&nbsp;&nbsp;&nbsp;{value}</div>
                      )
                    })
                    :
                    null
                }

                {/* 参照 或 枚举 */}
                {
                  !isCustomize ?
                  <div className='refList-title' >{`${RefShowField == 'Code' && it['Name'] ? it[RefShowField] + "/" + it['Name'] : it[RefShowField || 'Name']}`}</div>
                  :
                  null
                }
                {
                  !isCustomize && template && template.length > 0 &&
                  template.map((item, j) => (
                      <div key={j} className='refList-row' style={{ width: item.RowWidth + '%' }}>{item.Caption}:{it[item.Field.replace('.', '_')]}{this.renderDesensitizationIcon(it,item,desensitizationFileds)}</div>
                    ))
                }
              </div>
              <Ticon  type='gouxuan' className = 'gouxuan' style={{ display: it.selected ? 'block' : 'none'}} />
            </div>);
        })}
      </div>
    )
  }

}
